import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = {
  action: "#",
  id: "formEdit",
  class: "needs-validation",
  autocomplete: "off"
}
const _hoisted_4 = { class: "row d-flex justify-content-center" }
const _hoisted_5 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_6 = { class: "row d-flex justify-content-center" }
const _hoisted_7 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_8 = {
  key: 0,
  class: "row d-flex justify-content-center align-self-center"
}
const _hoisted_9 = { class: "col-xl-8 col-md-10 col-12 d-grid gap-2" }
const _hoisted_10 = {
  class: "alert alert-danger",
  role: "alert",
  style: {"background-position-y":"8px"}
}
const _hoisted_11 = { class: "row d-flex justify-content-center mt-1" }
const _hoisted_12 = { class: "col-xl-8 col-md-10 col-12 d-grid gap-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "progress progress-indeterminate"
}
const _hoisted_15 = { class: "visually-hidden" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "progress-bar",
  role: "progressbar"
}, null, -1)

import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import api from "@/services/BookingService";
import _ from "lodash";
import { FindBookToEditViewModel } from "@/models/Appointment/FindBookToEditViewModel";
import { useI18n } from "vue-i18n";
import { FormValidate } from "bootstrap-italia";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditBook',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const { t } = useI18n();

const lastname = ref("");
const friendlycode = ref("");

const tenantId = ref(null);

const loading = ref(false);
const loadingFromQueryData = ref(false);

const error = ref(false);
const errorMessage = ref(t("messages.bookingNotFound"));

const validate = ref<any>(null);

onMounted(() => {
    //verifico se ho dei parametri in query per recuperare l'appuntamento (parametri obbligatori: TenantID, Codice prenotazione e cognome)
    if (!_.isEmpty(route.query) && route.query.tenant) {
        tenantId.value = route.query.tenant;
    }

    if (!_.isEmpty(route.query) && route.query.lnm && route.query.cser) {
        loadingFromQueryData.value = true;
        lastname.value = route.query.lnm as string;
        friendlycode.value = route.query.cser as string;

        findBook(true);
    }

    validate.value = new FormValidate("#formEdit" as any, {
        errorFieldCssClass: "is-invalid",
        errorLabelCssClass: "form-feedback",
        errorLabelStyle: "",
        focusInvalidField: true,
        successLabelCssClass: "labelblack"
    });

    validate.value.addField("#lastName", [
        {
            rule: "required",
            errorMessage: t("required.lastName")
        }
    ]);

    validate.value.addField("#friendlyCode", [
        {
            rule: "required",
            errorMessage: t("required.friendlyCode")
        }
    ]);
});

const lastNameLabel = computed(() => {
    let label = t("common.lastName");
    label = label + " *";
    return label;
});

const friendlyCodeLabel = computed(() => {
    let label = t("common.friendlyCode");
    label = label + " *";
    return label;
});

const findBook = (skipValidation?: boolean) => {
    var data: FindBookToEditViewModel = {
        bookingCode: friendlycode.value,
        lastName: lastname.value,
        tenantId: tenantId.value
    };

    if (!skipValidation) {
        validate.value.validate();
        validate.value.onSuccess((result: any) => {
            loading.value = true;
            error.value = false;
            data = {
                bookingCode: friendlycode.value,
                lastName: lastname.value,
                tenantId: store.tenantSelected.id || tenantId.value
            };

            api.getBookingToEdit(data)
                .then((res) => {
                    if (res && res.data && res.data.booking) {
                        store.bookedit = res.data.booking;
                        loading.value = false;
                        loadingFromQueryData.value = false;
                        router.push({ name: "editbookresumedata" });
                    }
                })
                .catch((err) => {
                    if (err && err.response) {
                        if (err.response.status === 500) {
                            if (err.response.data && err.response.data.errorMessage) {
                                errorMessage.value = err.response.data.errorMessage;
                            }
                        }
                    }
                    error.value = true;
                    loading.value = false;
                    loadingFromQueryData.value = false;
                    console.log(err);
                });
        });
    }
    else {
        api.getBookingToEdit(data)
        .then((res) => {
            if (res && res.data && res.data.booking) {
                store.bookedit = res.data.booking;
                loading.value = false;
                loadingFromQueryData.value = false;
                router.push({ name: "editbookresumedata" });
            }
        })
        .catch((err) => {
            if (err && err.response) {
                if (err.response.status === 500) {
                    if (err.response.data && err.response.data.errorMessage) {
                        errorMessage.value = err.response.data.errorMessage;
                    }
                }
            }
            error.value = true;
            loading.value = false;
            loadingFromQueryData.value = false;
            console.log(err);
        });
    }
};

return (_ctx: any,_cache: any) => {
  const _component_KInputText = _resolveComponent("KInputText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, [
          _createElementVNode("b", null, _toDisplayString(_unref(t)("titles.findBooking")), 1)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KInputText, {
            name: "lastName",
            id: "lastName",
            modelValue: lastname.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lastname).value = $event)),
            labelText: lastNameLabel.value
          }, null, 8, ["modelValue", "labelText"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_KInputText, {
            name: "friendlyCode",
            id: "friendlyCode",
            modelValue: friendlycode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((friendlycode).value = $event)),
            labelText: friendlyCodeLabel.value
          }, null, 8, ["modelValue", "labelText"])
        ])
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(errorMessage.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "submit",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (findBook(false))),
            class: "btn btn-primary btn-progress",
            disabled: loading.value
          }, [
            _createTextVNode(_toDisplayString(_unref(t)("common.findBooking")) + " ", 1),
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("common.loadingText")), 1),
                  _hoisted_16
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_13)
        ])
      ])
    ], 512), [
      [_vShow, !loadingFromQueryData.value]
    ])
  ], 64))
}
}

})